let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kDqHr")).then(() => parcelRequire('9JsQ8'));